























import { defineComponent, Ref, ref, onActivated, PropType, computed } from '@vue/composition-api';
import { CurrentUserModel } from '@/models/current-user';
import { useBroadcast } from '@/common/utils';
import { useApolloModel } from 'vue-apollo-model';
import { LoginSource } from '@/common/const';
import { useLog } from '../../../common/log';
import { handleUrlDecode } from '@/common/util/url';
import { RouteName } from '@/router';
import type { SearchUI } from '../../../../typings/ui';

export default defineComponent({
    props: {
        searchUiData: {
            type: Object as PropType<SearchUI>,
        },
    },
    setup(props, { root, emit }) {
        const searchKey = ref(handleUrlDecode((root.$route.query.searchKey as string)));
        const currentUserModel = useApolloModel(CurrentUserModel);
        const broadcast = useBroadcast();
        const searchInput: Ref<HTMLDivElement | null> = ref(null);
        const log = useLog();
        const searchInputStyle = computed(() => {
            if (props.searchUiData) {
                return {
                    color: props.searchUiData.searchTextColor,
                    background: props.searchUiData.inputBackground,
                };
            }
        });
        const searchButtonStyle = computed(() => {
            if (props.searchUiData) {
                return {
                    backgroundColor: props.searchUiData.searchButtonBackground,
                    color: props.searchUiData.searchButtonTextColor,
                    fontWeight: props.searchUiData.searchButtonFontWeight,
                };
            }
            return {};
        });
        const searchIconUrl = computed(() => {
            if (props.searchUiData) {
                return {
                    background: `url(${props.searchUiData.searchButtonIconUrl}) no-repeat`,
                };
            }
            return {};
        });

        onActivated(() => {
            searchKey.value = handleUrlDecode((root.$route.query.searchKey as string));
        });

        function login() {
            if (!currentUserModel?.userInfo.id) {
                searchInput.value?.blur();
                let searchUrl = '/';
                if (
                    searchKey.value !== ''
                    && searchKey.value.trim().length !== 0) {
                    searchUrl = root.$router.resolve({
                        path: '/search/video',
                        query: { searchKey: searchKey.value },
                    }).href;
                }
                broadcast('login', {
                    // 登录源，供日志上报使用
                    source: LoginSource.SEARCH,
                    redirect: searchUrl,
                });
            }
        }
        function search() {
            emit('search');
            log({
                event_name: 'SEARCH_BUTTON',
                event_value: {
                    search_word: searchKey.value,
                },
            });
            // if (currentUserModel?.userInfo.id) {
            if (
                typeof searchKey.value === 'string'
                && searchKey.value !== root.$route.query.searchKey
                && searchKey.value !== ''
                && searchKey.value.trim().length > 0
            ) {
                if (root.$route.name === RouteName.Home) {
                    window.open(`/search/video?searchKey=${encodeURIComponent(searchKey.value)}`);
                    return;
                }
                root.$router.push({
                    path: '/search/video',
                    query: { searchKey: encodeURIComponent(searchKey.value) },
                });
            }
            // } else {
            //     login();
            // }
        }
        return {
            searchKey,
            search,
            login,
            searchInput,
            searchButtonStyle,
            searchIconUrl,
            searchInputStyle,
        };
    },
});
